'use client';

import React, { useState } from 'react';
import { Stack } from '@mui/material';
import DropdownMenu from './DropdownMenu';
import NavTitle from './NavTitle';

/**
 * @name PrimaryNav
 * @description Component to display list of primary navs
 * @param {object} root0  - destructured object
 * @param {object} root0.navs - Data from Strapi
 * @returns {JSX.Element} ReactJs Element
 */
const PrimaryNav = ({ navs }) => {
  const [selectedNav, setSelectedNav] = useState(null);

  /**
   * @function handleClick
   * @description Function set the selected nav from nav list
   * @param {object} e -event
   * @param {object} nav -Navigation data from strapi
   */
  const handleClick = (e, nav) => {
    e.preventDefault();
    if (selectedNav && selectedNav.title === nav.title) {
      setSelectedNav(null);
    } else {
      setSelectedNav(nav);
    }
  };

  /**
   * @function handleClose
   * @description Function to close the dropdow
   */
  const handleClose = () => {
    setSelectedNav(null);
  };

  return (
    <Stack direction='row' justifyContent='space-between'>
      {navs?.map(nav => (
        <React.Fragment key={nav.title}>
          <NavTitle nav={nav} handleClick={handleClick} handleClose={handleClose} />
          {selectedNav?.title === nav.title && (
            <DropdownMenu handleClose={handleClose} nav={selectedNav} />
          )}
        </React.Fragment>
      ))}
    </Stack>
  );
};

PrimaryNav.displayName = 'PrimaryNav';
export default PrimaryNav;
